export const properties = {
    volverCoopeuch: "Volver a Coopeuch.cl",
    irCoopeuch:"Ir a Coopeuch.cl",
    urlHomeCoopeuch: "https://www.coopeuch.cl",
    urlCoopeuch: "https://www.coopeuch.cl/personas/tarjeta-credito.html",
    urlNoSocios: 'https://enrolamientodigital.coopeuch.cl/',
    urlTarjetaDale: 'https://dalecoopeuch.cl/',
    conoceSusBeneficions: "Conoce sus beneficios",
    urlBeneficios: "https://www.coopeuch.cl/personas/tarjeta-credito.html",

    casosBordes :{
        ListaNegra : {
            titulo: 'Solicitud de tarjeta de Crédito',
            subtitulo: '¡Lo sentimos! No es posible continuar con la solicitud',
            bajada: 'No cumples con las condiciones para solicitar una tarjeta de Crédito.',
            textoBoton: 'Ver políticas de crédito',
            textoBotonDos: 'Volver a Coopeuch.cl',
            textoBeneficios: 'Conoce sus beneficios'
        },
        CasoBorde: {
            titulo: 'Solicitud de tarjeta de Crédito',
            subtitulo: '¡Lo sentimos! No es posible continuar con la solicitud',
            bajada: 'No cumples con las condiciones para solicitar una tarjeta de Crédito.',
            bajadaSolicitudEnProceso: 'Usted ya cuenta con una solicitud de Tarjeta de Crédito cursada.',
            bajadaCedulaNoValida: 'Cédula No Vigente o errónea.',
            textoBeneficios: 'Ver políticas de crédito',
            textoBotonDos: 'Volver a Coopeuch.cl'    
        },
        ErrorServidor: {
            titulo: 'Solicitud de tarjeta de Crédito',
            subtitulo: '¡Lo sentimos!',
            bajada: 'No se ha podido realizar la solicitud.',
        }
    },
    pasos:{
        paso1: {
            aceptarButton: 'Verificar y continuar',
            errorRut: 'Debes ingresar un RUT válido',
            errorNroSerie: 'Debes ingresar un N° válido',
            verificacion:{
                titulo: "Primero, verificaremos tu cédula de identidad",
                autorizo: "¿Autorizas a Coopeuch a acceder a tu información del Registro Civil?",
                chechbox: "Sí, autorizo a Coopeuch a acceder a mi información.",
                dialogo: {
                    titulo:"¿Dónde esta el N° de serie o documento?"
                }
            }
        },
        paso2:{
            aceptarButton: 'Continuar y ver tarjeta',
            volverBoton: 'Volver a Coopeuch.cl',
            datosPersonales:{
                renta: "Nos referimos al monto final que recibes como pago luego de que se hayan descontado tus cotizaciones, previsiones y el seguro de cesantía."
            },
            sucursales:{
                chechbox: "Buscar sucursales cercanas a esta residencia para retirar mi tarjeta."
            },
            modalRevisaDatosRenta: {
                titulo: 'Antes de continuar revisa tus datos',
                descripcion: 'Estos deben ser',
                descripcion2: ' exactos ',
                descripcion3: 'como la ',
                descripcion4: 'cifra de tu renta',
                descripcion5: 'Tu información será verificada al momento de la entrega de la Tarjeta de Crédito.',
                botonContinuar: 'Continuar'
            }
        },
        paso4: {
            aceptarButton: 'Confirmar solicitud',
            volverBoton: 'Volver a Coopeuch.cl'
        },
        paso5: {}
    },
    encuestaSatisfaccion: {
        titulo: 'Tu opinión es de suma importancia para que mejoremos la experiencia digital de nuestros socios, contesta esta pequeña encuesta para que sigamos creciendo juntos.',
        pregunta1Titulo: '¿Qué tan satisfecho te encuentras con el proceso de solicitud de Tarjeta de Crédito Coopeuch?',
        pregunta1Label1: 'Cuéntanos en qué podemos mejorar',
        pregunta1Label2: 'Cuéntanos que fue lo que más te gustó y cómo podríamos mejorar',
        pregunta2Titulo: '¿Qué tan fácil o difícil fue solicitar tu Tarjeta de Crédito Coopeuch?',
        pregunta2Label1: 'Cuéntanos cómo podríamos mejorar',
        pregunta2Label2: '¡Genial! Cuéntanos cómo podríamos mejorar',
        exitoTitulo: '¡Muchas gracias por tu colaboración!',
        exitoDescripcion: 'Tus respuestas han sido enviadas con éxito.',
        exitoBoton: 'Volver a Coopeuch.cl',
        errorTitulo: '¡Lo sentimos! Ha ocurrido un error al enviar la encuesta',
        errorDescripcion: 'Por favor, inténtalo nuevamente.',
        errorBoton: 'Reintentar'
    },
    encuestaAbandono: {
        titulo: 'Queremos seguir mejorando la experiencia digital de nuestros usuarios, tu opinión es muy importante para nosotros.',
        pregunta1Titulo: '¿Por qué estás abandonando?',
        pregunta1Opciones: [
            {
                orden: 1,
                indice: 15,
                descripcion: 'La información no me quedó clara',
                estado: false
            },
            {
                orden: 2,
                indice: 16,
                descripcion: 'Me resultó muy largo',
                estado: false
            },
            {
                orden: 3,
                indice: 17,
                descripcion: 'Encontré difícil la contratación',
                estado: false
            },
            {
                orden: 4,
                indice: 18,
                descripcion: 'Los costos no se ajustan a lo que busco',
                estado: false
            },
            {
                orden: 5,
                indice: 19,
                descripcion: 'Otro motivo',
                estado: false,
                abreInput: true
            }
        ],
        pregunta1Label1: 'Cuéntanos tu motivo',
        exitoTitulo: '¡Muchas gracias por tu colaboración!',
        exitoDescripcion: 'Tus respuestas han sido enviadas con éxito.',
        exitoBoton: 'Volver a Coopeuch.cl',
        errorTitulo: '¡Lo sentimos! Ha ocurrido un error al enviar la encuesta',
        errorDescripcion: 'Por favor, inténtalo nuevamente.',
        errorBoton: 'Reintentar'
    },
    tarjetaActiva:{
        titulo: "Solicitud de tarjeta de Crédito",
        subtitulo: "Ya tienes una tarjeta de crédito en Coopeuch",
        descripcion: "Puede utilizarla en Chile y el extranjero, permite realizar compras y avances en cuotas con cargo a una linea de crédito o cupo."
    },
    solicitudFinalizada:{
        titulo: "Tu Tarjeta de Crédito esta esperando en Coopeuch",
        tarjetaDorada: "MasterCard Dorada",
        saldo:{
            titulo: "Saldo y características",
            caracteristicas: [
                "Cupo en pesos y dólares, permite compras y avances en dinero en Chile y en el extranjero.",
                "Todas las compras acumulan &quot;Puntos Coopeuch&quot;. Accede a descuentos y beneficios en alianzas."
            ]
        },
        comprobante: {
            titulo: "Comprobante",
            subtitulo: "Solicitud de tarjeta de crédito."
        },
        sucursal:{
            titulo: "Sucursal de retiro:"
        },
        fecha:{
            titulo: "Fecha:"
        },
        horario:{
            titulo: "Horario de atención:"
        },
        documentosSucursal:{
            titulo: "En sucursal te pediremos",
            cedula:{
                titulo: "Tu cédula de identidad", 
                subtitulo: "Vigente y en buen estado para comprobar tu identidad."
            },
            cotizaciones:{
                titulo: "Tus cotizaciones previsionales", 
                subtitulo: "Últimas 12 cotizaciones (online o papel)."
            },
            liquidaciones:{
                titulo: "Tus liquidaciones de sueldo", 
                subtitulo: "Últimas 3 liquidaciones (online o papel)."
            }
        }
    },
    selloCoopeuch:{
        texto: "Solicitudes 100% seguras."
    },

    futuratarjeta:{

        BeneficiosGold:{

            titulo: 'Úsala donde y como quieras',
            bajada: 'Realiza compras y avances dentro y fuera de Chile. Cupos en pesos y dólares.',
            tituloDos: 'Paga sin contacto',
            bajadaDos:'Tarjetas con tecnología Contactless. Para cuidarte a ti y a los demás..',
            tituloTres:'Acumula puntos Coopeuch',
            bajadaTres:'Accede a descuentos y beneficios en alianzas.'

        },

        Beneficios:{

            beneficioUno: 'Úsala donde y como quieras',
            textoUno: 'Realiza compras y avances dentro y fuera de Chile. Cupos en pesos y dólares.',
            beneficioDos: 'Paga sin contacto',
            textoDos:'Tarjetas con tecnología Contactless. Para cuidarte a ti y a los demás.',
            beneficioTres:'Acumula puntos Coopeuch',
            textoTres:'Accede a descuentos y beneficios en alianzas.'

        },

        BeneficiosDale:{
            titulo1:'Controla tu plata',
            texto1:'Es más segura ya que tú defines cuánto cargas y cuánto gastas.',
            titulo2:'Siempre a tu disposición',
            texto2:'Recuerda que si tienes cualquier duda o consulta, puedes consultar nuestros tutoriales.',
            titulo3:'Amamos el eCommerce',
            texto3:'Compra en AliExpress, Wish, Amazon y muchos más. Recarga y paga con tu cuenta Paypal.',
            textoBeneficios: '¿Cuáles son los beneficios?'
        },

        Requisito:{
            titulo:'Hazte socio Coopeuch',
            texto:'Accede a descuentos y beneficios en alianzas.'
        },

        Comisiones:{
            tituloUno:'Administración anual:',
            textoUno:'Mantención anual:',
            tituloDos:'Avance en cuotas desde oficinas habilitadas: ',
            textoDos:'Avance en cuotas cajeros automáticos:',
            tituloTres:'Avance en efectivo en cajeros automáticos: ',
            textoTres:'Avances internacionales:',
            tituloCuatro:'Compras internacionales:',
            textoCuatro:'Compra en casino internacional:'
        },

        Mensaje(uf){
         return `*Los montos en pesos han sido calculados al valor UF del día de hoy (${uf}).`
        },
        goldcardTitulo:'Mastercard Dorada',
        goldcardBajada: 'Permite acceder a la red de aceptación global de Mastercard, con exclusivos beneficios en Chile y el extranjero.',
        goldcardBenificios: '¿Cuáles son los beneficios?',
        blackcard:'Mastercard Internacional',
        bluecard:'Tarjeta Prepago Dale',
        hazteSocioTitulo: 'Tarjetas Mastercard',
        hazteSocioBajada: 'Permite acceder a la red de aceptación global de Mastercard, con exclusivos beneficios en Chile y el extranjero.',
        hazteSocioBeneficios: '¿Cuáles son los beneficios de tu Tarjeta de Crédito?',
        hazteSocioRequisitosTitulo: 'Necesitas ser Socio para tener tu Tarjeta de Crédito',
        hazteSocioRequisitosSubtitulo: 'Hazte Socio Coopeuch',
        hazteSocioRequisitosDesc1: 'Hazte Socio ahora y ',
        hazteSocioRequisitosDesc2: 'luego solicita tu Tarjeta de Crédito',
        hazteSocioRequisitosDesc3: ', así podrás acceder a todos nuestros beneficios y descuentos exclusivos que tenemos para ti.',
        boteneraTextos:{
             botonUno: 'Volver a Coopeuch.cl',
             botonDos: 'Solicitar mi tarjeta'
        },
        boteneraTextosDale:{
            botonUno: 'Volver a Coopeuch.cl',
            botonDos: 'Solicitar mi tarjeta Dale'
       },
       botoneraTextoNoSocioBlack:{
            botonUno: 'Volver a Coopeuch.cl',
            botonDos: 'Hazte Socio + Cuenta Vista'
       },
       Tarifas:{
            titulo1: "Administración semestral:",
            infoTarifas(valorEnUf, textoUf){
                return `si cada 6 meses acumulas compras y/o avances por ${valorEnUf}* (${textoUf}) o más.`},
            titulo2: "Comisión por Administración Mensual:",
            infoTarifas2: "Si un mes no hay facturación,"
    },

    },
    comprobante:{
        title: "!Felicitaciones!",
        Mensaje:{
            texto:"Has solicitado tu tarjeta de crédito",
            texto2: (dias,fecha) =>{
                return `Desde el ${fecha}, tendrás un plazo máximo de ${dias} días para retirar tu tarjeta en sucursal.`;
            },
            textodias: (dias) =>{
                return `Esta solicitud y su tarjeta tienen una validez de ${dias} días para retirar desde la sucursal que elegiste.`
            }
        },
        comprobante:{
            titulo:"Comprobante",
            subtitulo:"Solicitud de tarjeta de crédito"
        },
        sucursal:{
            titulo:"Sucursal de retiro:",
            subtitulo:"Agustina N° 1141, Santiago"
        },
        fecha:{
            titulo:"Fecha de retiro:" ,
            subtitulo:"Desde el 18/07/2021"
        },
        fechaSucursal:{
            titulo:"Horario de atención: ",
            subtitulo:"Lunes a Jueves: 09:00 Hrs a 17:00 Hrs.",
            subtitulo2:"Viernes: 09:00 Hrs a 16:00 Hrs."
        },
        cedula:{
            titulo:"Cédula de identidad",
            subtitulo:"Vigente y en buen estado para comprobar tu identidad.",
        },
        cotizaciones:{
            titulo:"Cotizaciones previsionales",
            subtitulo:"Con tu autorización, accederemos a tus últimas 12 cotizaciones vía Previred."
        },
        liquidaciones:{
            titulo:"Tus liquidaciones de sueldo",
            subtitulo:"Con tu autorización, accederemos a tus últimas 3 liquidaciones de sueldo vía Previred."
        },
        footer:{
            texto:"Se envió una copia de este comprobante a tu email: ",
            texto2:"Fecha: ",
            texto3:"Serie operación: "
        }
        
    }

    
}

export default properties;